import type { View } from '@/src/core/vtk/types';
import type { Point3 } from './rigid';

const views = new Map<string, { view: View; container: HTMLElement }>();
export function observeView(id: string, view: View, container: HTMLElement) {
  views.set(id, { view, container });
  return () => views.delete(id);
}
export function projectWorld(id: string, xyz: Point3) {
  const entry = views.get(id);
  if (!entry) throw new Error(`View ${id} is not mounted.`);
  const { view, container } = entry;
  const [x, y] = view.renderWindowView.worldToDisplay(...xyz, view.renderer);
  const canvas = container.querySelector('canvas')!;
  const rect = canvas.getBoundingClientRect();
  return { x: x * rect.width / canvas.width, y: rect.height - y * rect.height / canvas.height };
}
/** Camera navigation used by the normal Go to index control. */
export function centerView(id: string, xyz: Point3) {
  const entry = views.get(id); if (!entry) return;
  const camera = entry.view.renderer.getActiveCamera(); const focal = camera.getFocalPoint(); const position = camera.getPosition();
  camera.setPosition(...position.map((n, i) => n + xyz[i] - focal[i]) as Point3);
  camera.setFocalPoint(...xyz); entry.view.renderer.resetCameraClippingRange(); entry.view.requestRender();
}
